import React, { Component } from "react";
import { toast } from "react-toastify";
import { Table, Form, Button, Modal } from "react-bootstrap";

import "./iam-roles.css";
import axios from "../../../axios";
import apiError from "../../../error";
import { getCookie } from "../../../function";
import Spinner from "../../../component/spinner/spinner";
import "../../../component/rightside-modal/rightside-modal.css";

export class CreateRoleModal extends Component {
	constructor(props) {
		super(props);
		this.isTAconnected = getCookie("isTAconnected");
		this.isTASyncing = getCookie("isTASyncing");
		this.state = {
			name: "",
			description: "",
			buttonLoading: false,
			policies: [],
			selectedPolicyIds: [],
            selectedAllPolicies: false,
		};
	}

	componentDidUpdate(prevProps) {
		if (this.props.show && !prevProps.show) {
			if (this.props.roleId && this.props.roleId > 0) {
				this.loadPolicies(() => this.loadRole(this.props.roleId));
			} else {
				this.resetForm();
				this.loadPolicies();
			}
		}
	}

	loadRole = (roleId) => {
		axios
			.get("/api/roles/" + roleId)
			.then((res) => {
				const role = res.data.role || res.data;
				const policyRoles = role.policies || role.policyRoles || [];
				const policyIds = policyRoles?.map(
					(p) => p?.policyId ?? p?.policy_id ?? p?.id
				) || [];
				this.setState({
					name: role.name || "",
					description: role.description || "",
					selectedPolicyIds: policyIds,
				});
			})
			.catch((err) => apiError(err));
	};

	loadPolicies = (callback) => {
		axios
			.get("/api/policy/get", {})
			.then((res) => {
				this.setState({ policies: res.data.policies || [] }, () => {
					callback && callback();
				});
			})
			.catch((err) => apiError(err));
	};

	resetForm = () => {
		this.setState({
			name: "",
			description: "",
			selectedPolicyIds: [],
			buttonLoading: false,
		});
	};

	togglePolicy = (policyId) => {
		this.setState((prev) => {
			const idx = prev.selectedPolicyIds.indexOf(policyId);
			const selectedPolicyIds =
				idx === -1
					? [...prev.selectedPolicyIds, policyId]
					: prev.selectedPolicyIds.filter((id) => id !== policyId);
			return { selectedPolicyIds };
		});
	};

	toggleSelectAll = () => {
		this.setState((prev) => {
			const allSelected = prev.policies.length > 0 && prev.selectedPolicyIds.length === prev.policies.length;
			const selectedPolicyIds = allSelected
				? []
				: prev.policies.map((p) => p.id);
			return { selectedPolicyIds };
		});
	};

	handleCreate = () => {
		if (!this.state.name || !this.state.name.trim()) {
			toast.error("Please enter role name");
			return;
		}
		if (!this.state.description || !this.state.description.trim()) {
			toast.error("Please enter role description");
			return;
		}
		if (this.state.selectedPolicyIds.length === 0) {
			toast.error("Please select at least one policy");
			return;
		}
		this.setState({ buttonLoading: true });

		const isEdit = this.props.roleId && this.props.roleId > 0;
		const payload = {
			name: this.state.name.trim(),
			description: this.state.description.trim(),
			policyIds: this.state.selectedPolicyIds,
		};

		const request = isEdit
			? axios.patch("/api/roles/" + this.props.roleId, payload)
			: axios.post("/api/roles", payload);

		request
			.then(() => {
				this.setState({ buttonLoading: false });
				toast.success(isEdit ? "Role updated successfully" : "Role created successfully");
				this.props.load && this.props.load();
				this.props.handleModal && this.props.handleModal();
				this.resetForm();
			})
			.catch((err) => {
				this.setState({ buttonLoading: false });
				apiError(err);
			});
	};

	handleClose = () => {
		this.resetForm();
		this.props.handleModal && this.props.handleModal();
	};

	render() {
		const disabled = this.isTAconnected || this.isTASyncing;
		const { policies, selectedPolicyIds } = this.state;

		return (
			<Modal
				className="info-filter right mainfooterModal right-modal-wrap"
				show={this.props.show}
				onHide={this.handleClose}
				autoFocus
				keyboard
			>
			<Modal.Header closeButton>
				<div>
					<h5>{this.props.roleId ? "Edit Role" : "Create Role"}</h5>
					<p>{this.props.roleId ? "Update role details and assigned policies." : "Add a new role with name, description and assign policies."}</p>
				</div>
			</Modal.Header>
				<Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
					<div className="addUserDetail">
						<div className="row">
							<div className="col-md-12">
								<Form.Label>Role Name<span className="red-star">*</span></Form.Label>
								<Form.Group>
									<Form.Control
										type="text"
										placeholder="Role name"
										value={this.state.name}
										onChange={(e) => this.setState({ name: e.target.value })}
										disabled={disabled}
									/>
								</Form.Group>
							</div>
							<div className="col-md-12">
								<Form.Label>Description<span className="red-star">*</span></Form.Label>
								<Form.Group>
									<Form.Control
										as="textarea"
										rows={3}
										placeholder="Role description"
										value={this.state.description}
										onChange={(e) => this.setState({ description: e.target.value })}
										disabled={disabled}
									/>
								</Form.Group>
							</div>
						</div>
					</div>

					{policies && policies.length > 0 && (
						<div className="addUserDetail">
							<p>Select action for this role <span className="red-star">*</span></p>
							<div className="tableContainerWrapInner">
								<Table responsive size="sm">
									<thead className="bg-light">
										<tr>
											<th className="w-5">
												<Form.Check
													type="checkbox"
													checked={policies.length > 0 && selectedPolicyIds.length === policies.length}
													onChange={this.toggleSelectAll}
													disabled={disabled}
												/>
											</th>
											<th>Policy Name</th>
											<th>Type</th>
										</tr>
									</thead>
									<tbody>
										{policies.map((policy) => (
											<tr key={policy.id}>
												<td className="w-5">
													<Form.Check
														type="checkbox"
														checked={selectedPolicyIds.indexOf(policy.id) !== -1}
														onChange={() => this.togglePolicy(policy.id)}
														id={`policy-checkbox-${policy.id}`}
														disabled={disabled}
													/>
												</td>
												<td>{policy.name}</td>
												<td>{policy.type}</td>
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</div>
					)}
				</Modal.Body>
				<div className="modalFooter">
					<div className="row">
						<div className="col-md-12 text-right">
							<Button type="button" variant="secondary" className="mr-2" onClick={this.handleClose}>
								Cancel
							</Button>
							<Button
								className="btn btn-success"
								onClick={this.handleCreate}
								disabled={disabled || this.state.buttonLoading}
							>
							<Spinner loading={this.state.buttonLoading} />
							{this.props.roleId ? "Update Role" : "Create Role"}
							</Button>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

export default CreateRoleModal;
